import { all } from "redux-saga/effects";
import authSaga from "./authSaga";
import customerSaga from "./customerSaga";
import sancharSaga from "./sancharSaga";
import rechargeSaga from "./rechargeSaga";
import ecommerceSaga from "./ecommerceSaga";
import milansathiSaga from "./milansathiSaga";
import staticpageSaga from "./staticpageSaga";

export default function* rootSaga() {
    yield all([
        authSaga(),
        customerSaga(),
        sancharSaga(),
        rechargeSaga(),
        ecommerceSaga(),
        milansathiSaga(),
        staticpageSaga()
    ])
};